import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Injectable, Injector } from "@angular/core";
import { AngularFireFunctions } from "@angular/fire/compat/functions";
import { doc, docData, Firestore, getDoc } from "@angular/fire/firestore";
import { MatDialog } from "@angular/material/dialog";
import { Data, Router } from "@angular/router";
import { Device, DeviceInfo } from "@capacitor/device";
import { AuthService } from "@core/auth.service";
import { AuthStateService } from "@core/auth-state.service";
import { ErrorHandlerService } from "@core/ErrorHandlerService/error-handler.service";
import { UtilityService } from "@core/utility.service";
import { CreateUser } from "@interfaces/create-user.i";
import { getAuth, signInAnonymously } from "firebase/auth";
import { Timestamp } from "firebase/firestore";
import { BehaviorSubject, catchError, first, from, lastValueFrom, map, of, ReplaySubject, switchMap, take, throwError } from "rxjs";
import { CommonVariable } from "src/app/app.constants";
import { ApiLoaderComponent } from "src/app/components/api-loader/api-loader.component";
import { CommonService } from "src/app/services/common/common.service";
import { FirestoreDataService } from "src/app/services/firestore-data.service";
import { RequestBodyService } from "src/app/services/request-body.service";
import { RequestUserService } from "src/app/services/RequestBodyService/RequestUser/request-user.service";
import { SafeLocalStorageService } from "src/app/services/safe-local-storage.service";
import { SyndicateDataService } from "src/app/services/syndicate-data.service";
import { environment } from 'src/environments/environment';
import { UserfirebaseService } from "../userfirebase/userfirebase.service";
const zero = 0;

@Injectable({
  providedIn: "root",
})
export class UserserviceService {
  public requestBodyService: RequestBodyService;
  private safeLocalStorage = inject(SafeLocalStorageService);
  selectedlanguage$ = new BehaviorSubject(this.safeLocalStorage.getItem("language_code") || "");
  selectedCurrency: string;
  callSigUpForSalesResponse$ = new BehaviorSubject(null);
  public angularFireFunctions: AngularFireFunctions;
  public userBalance: Data;
  userSyndicateList: Data[] = [];
  public userData: Data;
  public checkWinning = false;
  public ongoingSyndicate = false;
  public syndicateLoadedData: Data;
  private activeSyndicateName: string | null = null;
  public preferredCurrency: string;
  public currencySymbol: string = "£";
  public onBoardState: string;
  public pwaSegmentStatus: string;
  public active_jackpot = false;
  userRequest$ = new ReplaySubject<Data>(1);
  userId = this.authService.getUid$("UserserviceService").pipe(
    switchMap(userId => {
      if (!userId) {
        return of(null);
      }
      return userId;
    })
  );

  constructor(
    private firestore: Firestore,
    private matDialog: MatDialog,
    private authService: AuthService,
    private injector: Injector,
    private RequestUserService: RequestUserService,
    private router: Router,
    private userfirebase: UserfirebaseService,
    private http: HttpClient,
    private utility: UtilityService,
    private syndicate: SyndicateDataService,
    private firestoreDataService: FirestoreDataService,
    private errorhandlerService: ErrorHandlerService,
    private commonService: CommonService,
    private authStateService: AuthStateService
  ) { }
  async addDocumentForAsyncModuleCall(): Promise<string> {
    let userId = null;
    this.authService.getUid$("UserserviceService").pipe(
      switchMap((userId) => {
        if (!userId) userId = null;
        userId = userId;
        return of(userId) || of(null);
      }));

    if (!userId) {
      throw new Error("User ID is not available");
    }

    try {
      const path_id = "uk3EJWK1yDt2hols9n6E";
      const doc_data = {
        expected_time_sec: 60,
        timeout_msg: false,
        user_outcome_message: "",
        late_response_inbox_msg: false,
      };
      const method = "create";
      const response: any = await lastValueFrom(
        this.firestoreDataService.getV2CloudFunction("updatefirestoredoc", { path_id, doc_data, method })
      );
      const docId = response?.path?.substring(response.path.lastIndexOf("/") + 1) || null;

      this.matDialog.open(ApiLoaderComponent, {
        panelClass: "api-loader-dialog-size",
        backdropClass: "decline-back-drop-color",
        data: docId,
      });

      return docId;
    } catch (error) {
      console.error("Error in addDocumentForAsyncModuleCall:", error);
      throw error;
    }
  }
  creditAutoRefresh(creditAmount) {
    return from(this.addDocumentForAsyncModuleCall()).pipe(
      switchMap((asyncModuleCallDocId) => {
        return this.firestoreDataService.getV2CloudFunction(
          "autocreditrefreshapiv2",
          this.requestBodyService?.refreshToken(creditAmount, asyncModuleCallDocId)
        );
      }),
      catchError((error) => {
        throw error;
      })
    );
  }
  creditAutoRefreshOff(creditAmount) {
    return from(this.addDocumentForAsyncModuleCall()).pipe(
      switchMap((asyncModuleCallDocId) => {
        return this.firestoreDataService.getV2CloudFunction(
          "autocreditrefreshapiv2",
          this.requestBodyService?.refreshTokenOff(creditAmount, asyncModuleCallDocId)
        );
      }),
      catchError((error) => {
        throw error;
      })
    );
  }
  turnOnCreditRefresh() {
    return this.commonService.getUid("turnOnCreditRefresh").pipe( // ✅ use commonService
      switchMap(async (userId) => {
        if (!userId) {
          console.error("User ID is invalid or not found.");
          return of(null);
        }
        // Update promo_details in Firestore
        const path_id = "1cblQl68QltRugb1YDAY";
        const method = "read";

        this.authService?.getV2CloudFunction("updatefirestoredoc", {
          path_id,
          method,
        }).pipe(
          map((snapshot: any) => snapshot?.data)
        ).subscribe({
          next: (docSnap: any) => {
            if (docSnap) {
              const promoDetails = docSnap?.promo_details || [];
              const updatedPromoDetails = promoDetails.map(promo => promo.promo_name === "activate_auto_topup" ? { ...promo, status: true } : promo);
              this.authService.getV2CloudFunction("updatefirestoredoc", {
                path_id: "1cblQl68QltRugb1YDAY",
                doc_data: { promo_details: updatedPromoDetails },
                method: "update",
              }).pipe(catchError((error) => of(error))).subscribe();
            }
          },
          error: (error: any) => {
            console.error("Error fetching promo details:", error);
          }
        });
        const statusDocPath = `users/${userId}/in_app_notification/status`;

        return from(getDoc(doc(this.firestore, statusDocPath))).pipe(
          switchMap((snapshot) => {
            const data = snapshot.data() as { out_of_points_promotion?: any };

            if (data?.out_of_points_promotion) {
              // ✅ Update document with out_of_points_promotion and credit_refresh
              return this.authService.getV2CloudFunction("updatefirestoredoc", {
                path_id: "KdpTQsnyjKvgqvjItVvT",
                doc_data: {
                  out_of_points_promotion: { updatedOn: new Date() },
                  credit_refresh: { status: true, low_trigger_threshold: 1, updatedOn: new Date() },
                },
                method: "update",
              }).pipe(
                catchError((error) => {
                  console.error(
                    "Error updating document with credit_refresh and out_of_points_promotion:",
                    error
                  );
                  return of(null);
                })
              );
            } else {
              // ✅ Update document with credit_refresh only
              return this.authService.getV2CloudFunction("updatefirestoredoc", {
                path_id: "KdpTQsnyjKvgqvjItVvT",
                doc_data: {
                  credit_refresh: { status: true, low_trigger_threshold: 1, updatedOn: new Date() },
                },
                method: "update",
              }).pipe(
                catchError((error) => {
                  console.error("Error updating document with credit_refresh:", error);
                  return of(null);
                })
              );
            }
          }),
          catchError((error) => {
            console.error("Error fetching document:", error);
            return of(null);
          })
        );
      })
    );
  }


  async loginAnonymously() {
    const auth = getAuth();
    return await signInAnonymously(auth);
  }

  createInstantUserInSql(user: CreateUser, uid: string) {
    if (!user || !uid) return;
    user.language_code = this.selectedlanguage$?.value;
    const request = this.RequestUserService.signupRequestInstant(user, uid);
    return this.firestoreDataService.getV2CloudFunction("apiv2", request);
  }

  callSigUpForSales(user: CreateUser, uid: string) {
    try {
      if (!user || !uid) return;
      user.language_code = this.selectedlanguage$?.value;
      CommonVariable.preferredLanguage = user?.language_code;
      CommonVariable.preferredCurrency = this.selectedCurrency ? this.selectedCurrency : user?.preferred_currency;
      const request = this.RequestUserService.signupRequestForSales(user, uid);
      //V2
      return this.firestoreDataService.getV2CloudFunction("callpartialregapiv2", request);
    } catch (err) {
      return err;
    }
  }

  createFbUserErrorHandling(): void {
    const proSub = localStorage.getItem("prosub_id");
    this.authService.logout().catch((error) => error);
    this.callSigUpForSalesResponse$?.next(null);
    if (proSub === null) return;
    this.router.navigateByUrl(`partial-registration?prosub_id=${proSub}`);
    const messages = {
      en: "Registration failed, please enter a correct phone number.",
      de: "Die Registrierung ist fehlgeschlagen, bitte geben Sie eine korrekte Telefonnummer ein.",
      fr: "L'inscription a échoué, veuillez saisir un numéro de téléphone correct.",
      it: "Registrazione fallita, si prega di inserire un numero di telefono corretto.",
      es: "La inscripción falló, por favor ingrese un número de teléfono correcto.",
    };
    this.showAnonymousUserMessage(messages[this.selectedlanguage$?.value]);
  }
  callSyncForSales(user: CreateUser, uid: string) {
    try {
      if (!user || !uid) return;

      user.language_code = this.selectedlanguage$?.value || user.language_code;
      CommonVariable.preferredLanguage = user.language_code;
      CommonVariable.preferredCurrency = this.selectedCurrency || user.preferred_currency || "default_currency";
      const request = this.RequestUserService.signupRequestForSales(user, uid);
      const callAuth = this.angularFireFunctions.httpsCallable("callPartialRegAPI");
      return callAuth(request);
    } catch (err) {
      return err;
    }
  }
  showAnonymousUserMessage(message: string = "") {
    const defaultMsg = {
      message: {
        line_1: message
          ? message
          : "Sorry, we are aboring this registration, looks like some issues wiht your account.",
        line_2: "",
      },
      style: {
        type: "Error",
        icon: "tick circle error.svg",
      },
    };
    this.authService.showToastMessage({}, defaultMsg);
  }

  public async userDetailsForLiveChat(): Promise<Data> {
    try {
      // Gate on customTokenReady$ to prevent permission-denied errors on iOS/Safari.
      this.authStateService.customTokenReady$.pipe(
        take(1),
        switchMap(() => this.commonService.getUid("").pipe(take(1)))
      ).subscribe({
        next: (res) => {
          if (!res) return;
          const balanceDocRef = doc(this.firestore, `users/${res}/balance/current`);
          docData(balanceDocRef).subscribe((balance: Data) => {
            this.userBalance = balance;
          });
        }
      })
      this.syndicate.userSyndicate$.subscribe(
        (syndicateData) => {
          if (syndicateData) {
            return (this.userSyndicateList = syndicateData);
          } else {
            return;
          }
        },
        (error) => {
          return error;
        }
      );
      this.userData = {
        title: "",
        name: "",
        email: "",
        customer_id: "",
        language: "",
        service_age: "",
        previous_login: "",
        bonus_credit_balance: "",
        reward_points_balance: "",
        cash_balance: "",
        lottery_participation: "",
        active_ongoing_syndicate: "",
        active_jackpot_trigger: "",
        pending_cashout: "",
        outstanding_check_winning: "",
        username: "",
        firstName: "",
        lastName: "",
        Registered_Since: "",
        phone: "",
        device: "",
        restriction: "",
        restriction_ttl: "",
      };

      const userData = await this.authService.userDetails$?.pipe(first()).toPromise();
      if (!userData) {
        return;
      }
      this.checkWinning = await new Promise<boolean>((resolve, reject) => {
        this.app_notification$.subscribe(
          (data: boolean) => {
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
      });
      if (this.userSyndicateList && this.userSyndicateList?.length > 0) {
        const syndicateLod = this.userSyndicateList;
        const activeSyndicate = syndicateLod?.find((syndicate) => syndicate?.syndicate_status === "active");
        const OngoingSyndicate = syndicateLod?.find((syndicate) => syndicate?.syndicate_type === "Ongoing");
        this.ongoingSyndicate = activeSyndicate !== undefined && OngoingSyndicate !== undefined;
        this.syndicateLoadedData = activeSyndicate || null;
        this.activeSyndicateName = this.syndicateLoadedData ? this.syndicateLoadedData?.syndicate_name : null;
      }
      let device: DeviceInfo;
      if (Device) {
        try {
          device = await Device?.getInfo();
        } catch (error) {
          return error;
        }
      }
      if (userData) {
        this.preferredCurrency = userData?.preferred_currency ?? CommonVariable.preferredCurrency;
        this.authService.getCurrencyList$.subscribe((res: Data) => {
          const CurrencyDetails = res?.details?.find((x: Data) => x?.currency_code === this.preferredCurrency);
          this.currencySymbol = CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol;
        });

        this.userData.title = userData?.title ? userData?.title : "Mr";
        this.userData.email = userData?.email ? userData?.email : "";
        this.userData.customer_id = this.userId ? this.userId : "";
        this.userData.language = "";
        this.userData.service_age = "";
        this.userData.previous_login = "";
        this.userData.bonus_credit_balance = this.currencySymbol + (this.userBalance?.credit || zero);
        this.userData.reward_points_balance = this.userBalance?.points ? this.userBalance?.points : zero;
        this.userData.cash_balance = this.currencySymbol + (this.userBalance?.winning_balance || zero);
        this.userData.lottery_participation = this.activeSyndicateName;
        this.userData.active_jackpot_trigger = "false";
        this.userData.active_ongoing_syndicate = this.ongoingSyndicate !== undefined ? this.ongoingSyndicate : false;
        this.userData.pending_cashout =
          this.userBalance?.withdraw_amount !== undefined && this.userBalance?.withdraw_amount !== null;
        this.userData.outstanding_check_winning = this.checkWinning !== undefined ? this.checkWinning : false;
        this.userData.username = this.userId ? this.userId : "";
        this.userData.firstName = userData?.name ? userData?.name : "";
        this.userData.lastName = userData?.surname ? userData?.surname : "";
        this.userData.Registered_Since = "";
        this.userData.device = device?.platform ? device?.platform : "Web";
        this.onBoardState = userData?.onboard_state ? userData?.onboard_state : "null";
        this.pwaSegmentStatus = userData?.pwa_segment_status ? userData?.pwa_segment_status : "null";
        this.userData.language = userData?.language_code ? userData?.language_code : "en";
        this.userData.restriction =
          !userData ||
            userData?.restriction === null ||
            userData?.restriction === undefined ||
            userData?.restriction === ""
            ? null
            : userData?.restriction;

        if (userData?.restriction_ttl) {
          try {
            const ttl = userData.restriction_ttl;

            if (ttl instanceof Timestamp) {
              this.userData.restriction_ttl = ttl.toDate(); // safest and cleanest
            } else if (ttl instanceof Date) {
              this.userData.restriction_ttl = ttl;
            } else if (typeof ttl === 'string' || typeof ttl === 'number') {
              this.userData.restriction_ttl = new Date(ttl);
            } else {
              throw new Error('Invalid restriction_ttl format');
            }
          } catch (error) {
            this.errorhandlerService.logError('Failed to parse restriction_ttl', error);
            this.userData.restriction_ttl = null;
          }
        }

        const syndicateJackpotTriggers$ = this.authService.getUid$("UserServiceService").pipe(
          switchMap(userId => {
            if (!userId) {
              return of(null)
            }
            return this.syndicate.getSyndicateJackpotTriggers(userId);
          })
        );
        syndicateJackpotTriggers$
          .pipe(
            map((triggers: Data) => {
              const activeJackpotTrigger = triggers?.find((trigger: Data) => trigger?.status === true);
              this.active_jackpot = activeJackpotTrigger !== undefined;
              return this.active_jackpot?.toString();
            })
          )
          .subscribe(
            (activeJackpotValue) => {
              this.userData.active_jackpot_trigger = activeJackpotValue?.toString();
            },
            (error) => {
              return error;
            }
          );
        let previous_login = "just now";
        if (userData?.previousLoginDatetime) {
          previous_login = this.calculateRegisteredTime(userData?.timestamp?.toDate());
        }
        this.userData.previous_login = previous_login;

        let protectedMsn = "";
        const phone = `+${userData.msn}`;
        if (phone !== "") {
          for (let digits = 0; digits < phone?.length - 3; digits++) {
            protectedMsn += "*";
          }
          for (let digits = phone?.length - 3; digits < phone?.length; digits++) {
            protectedMsn += phone[digits];
          }
        }
        this.userData.phone = protectedMsn;

        if (this.userData?.firstName !== "" && this.userData?.lastName !== "") {
          this.userData.name = `${this.userData?.firstName} ${this.userData?.lastName}`;
        } else if (this.userData.firstName !== "") {
          this.userData.name = this.userData?.firstName;
        } else if (this.userData.lastName !== "") {
          this.userData.name = this.userData?.lastName;
        }
      }
      let Registered_Since = "just now";
      if (userData?.timestamp) {
        Registered_Since = this.calculateRegisteredTime(userData?.timestamp?.toDate());
      }
      this.userData.Registered_Since = Registered_Since;
      this.userData.service_age = Registered_Since;
      for (const key in this.userData) {
        const value = this.userData[key];
        if (value === undefined || value === "") {
          delete this.userData[key];
        }
      }
      this.getChatDetails().subscribe((res: Data) => {
        if (!res) return;
        const userChatData = res.filter((item: Data) => item?.user.name === this.userData?.firstName);
        const chatID = userChatData[0]?.id ?? "";
        const livechatInitTime = userData?.last_support_contacted ? userData?.last_support_contacted?.toDate() : "N/A";
        const createdAtMilliseconds = new Date(livechatInitTime).getTime();
        const sevenDaysAgoTimestamp = Date.now() - 7 * 24 * 60 * 60 * 1000;
        const contactedSupportField =
          createdAtMilliseconds >= sevenDaysAgoTimestamp
            ? new Date(createdAtMilliseconds).toLocaleString() // Format the date & time as a string
            : "N/A";
        this.userData["Contacted support in last 7 days"] = contactedSupportField;
        this.getChatDetailsChatID(chatID)?.subscribe(
          (res: Data) => {
            // Extract and filter relevant values from the chat details
            const filteredValues = res?.messages?.flatMap(({ responses }) => {
              const value = responses?.[0]?.value;
              return value != null ? [typeof value === 'object' ? JSON.stringify(value) : value] : [];
            }).join(", ") || "N/A";
            this.setChatlioDetails(filteredValues);
          },
          () => {
            this.setChatlioDetails("N/A");
          }
        );
      });
    } catch (error) {
      return error;
    }
  }

  app_notification$ = this.userRequest$?.pipe(
    switchMap(user => {
      if (!user) {
        return of(false);
      }
      return this.authService.getUid$("UserserviceService").pipe(
        switchMap((userId) => {
          if (!userId) {
            return of(false);
          }
          const notifDocRef = doc(this.firestore, `users/${userId}/in_app_notification/status`);
          // Defense-in-depth gate (LOTTOSOCIAL-PWA-1MEE)
          return this.authStateService.customTokenReady$.pipe(
            take(1),
            switchMap(() => docData(notifDocRef).pipe(
              map(notification => notification?.winning ?? false)
            ))
          );
        })
      );
    })
  );

  private calculateRegisteredTime(date) {
    const currentDate = new Date().getTime();
    const timestampDate = date.getTime();

    const timeDifference = currentDate - timestampDate;

    const secondsInMinute = 60;
    const secondsInHour = secondsInMinute * 60;
    const secondsInDay = secondsInHour * 24;
    const secondsInMonth = secondsInDay * 30;
    const secondsInYear = secondsInDay * 365;

    const years = Math.floor(timeDifference / (1000 * secondsInYear));
    const months = Math.floor((timeDifference % (1000 * secondsInYear)) / (1000 * secondsInMonth));
    const days = Math.floor((timeDifference % (1000 * secondsInMonth)) / (1000 * secondsInDay));
    const hours = Math.floor((timeDifference % (1000 * secondsInDay)) / (1000 * secondsInHour));
    const minutes = Math.floor((timeDifference % (1000 * secondsInHour)) / (1000 * secondsInMinute));
    const seconds = Math.floor((timeDifference % (1000 * secondsInMinute)) / 1000);

    let result = "";

    if (years > 0) {
      result += years + (years === 1 ? " year " : " years ");
    }
    if (months > 0) {
      result += months + (months === 1 ? " month " : " months ");
    }
    if (days > 0) {
      result += days + (days === 1 ? " day " : " days ");
    }
    if (years === 0 && months === 0 && days === 0) {
      if (hours > 0) {
        result += hours + (hours === 1 ? " hour " : " hours ");
      }
      if (minutes > 0) {
        result += minutes + (minutes === 1 ? " minute " : " minutes ");
      }
      if (seconds > 0) {
        result += seconds + (seconds === 1 ? " second " : " seconds ");
      }
    }

    if (result === "") {
      result = "just now";
    } else {
      result += "ago";
    }

    return result;
  }
  getChatDetails() {
    const currentTime = Number(Date.now());
    const url = `https://api.chatbot.com/v2/chats?after=${currentTime}`;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${environment.chatbotApiKey}`,
    });
    return this.http.get(url, { headers: headers });
  }

  getChatDetailsChatID(ChatID: string) {
    const url = `https://api.chatbot.com/v2/chats/${ChatID}`;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${environment.chatbotApiKey}`,
    });
    return this.http.get(url, { headers: headers });
  }

  setChatlioDetails(issues: string) {
    const d = {
      userData: { ...this.userData, issue: issues },
      onBoardState: this.onBoardState,
      pwaSegmentStatus: this.pwaSegmentStatus,
    };
    localStorage.setItem("chatlioDetails", JSON.stringify(d));
  }

  setLastLiveChatTemp(currentTime: Date) {
    const liveChatInitTime = Timestamp.fromDate(currentTime); // Convert currentTime to Firestore Timestamp
    return this.authService.getUid$("UserserviceService").pipe(
      switchMap((userId) => {
        if (!userId) {
          console.error("User ID is not valid.");
          return;
        }
        const path_id = "yzF1Ss5eiMqnh91zQMtv";
        const doc_data = { last_support_contacted: liveChatInitTime };
        const method = "update";

        this.firestoreDataService.getV2CloudFunction("updatefirestoredoc", {
          path_id,
          doc_data,
          method,
        }).subscribe({
          error: (error) => {
            console.error("Error updating last support contacted:", error);
          }
        });
        return of(userId) || of(null);
      }));
  }
}
